import React, { useEffect, useState } from "react";
import { getLossSoldGoods } from "../../utils/dataFetch";

export default function LossSoldGoods() {
    const [lossSoldGoods, setLossSoldGoods] = useState({ lastMonth: [] });
    const [error, setError] = useState("");
    const [showAllRows, setShowAllRows] = useState(false);

    useEffect(() => {
        const fetchLossSoldGoods = async () => {
            try {
                const result = await getLossSoldGoods();
                setLossSoldGoods(result);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };

        fetchLossSoldGoods();
    }, []);

    const handleShowMoreToggle = () => {
        setShowAllRows((prevShowAllRows) => !prevShowAllRows);
    };

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                <h5 className="text-center fw-bold">Продажі в збиток</h5>
                {error && (
                    <div className="alert alert-danger m-auto rounded-5">
                        {error}
                    </div>
                )}
                {!error && (
                    <>
                        <div className="table-responsive rounded-4">
                            <table className="table table-sm table-striped table-light table-hover m-0">
                                <thead className="thead-dark">
                                    <tr>
                                        <th
                                            className="text-center align-middle"
                                            scope="col"
                                        >
                                            Назва
                                        </th>
                                        <th
                                            className="text-center align-middle"
                                            scope="col"
                                        >
                                            Збиток
                                        </th>
                                        <th
                                            className="text-center align-middle"
                                            scope="col"
                                        >
                                            Дата
                                        </th>
                                        <th
                                            className="text-center align-middle"
                                            scope="col"
                                        >
                                            Автор
                                        </th>
                                        <th
                                            className="text-center align-middle"
                                            scope="col"
                                        >
                                            Номер чеку
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lossSoldGoods.lastMonth
                                        .slice(
                                            0,
                                            showAllRows
                                                ? lossSoldGoods.lastMonth.length
                                                : 4
                                        )
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <th
                                                    className="text-center align-middle"
                                                    scope="row"
                                                >
                                                    {item.product_name}
                                                </th>
                                                <td className="text-center align-middle">
                                                    <span
                                                        className={`px-2 rounded-4 ${
                                                            parseFloat(
                                                                item.amount
                                                            ) >=
                                                            0.9 *
                                                                parseFloat(
                                                                    item.cost
                                                                )
                                                                ? "bg-warning-subtle"
                                                                : "bg-danger-subtle"
                                                        }`}
                                                    >
                                                        {(
                                                            parseFloat(
                                                                item.amount
                                                            ) -
                                                            parseFloat(
                                                                item.cost
                                                            )
                                                        ).toFixed(2)}
                                                    </span>
                                                </td>
                                                <td
                                                    className="text-center align-middle"
                                                    style={{ minWidth: "50px" }}
                                                >
                                                    {`${item.date.slice(
                                                        8,
                                                        10
                                                    )}.${item.date.slice(
                                                        5,
                                                        7
                                                    )} ${item.date.slice(
                                                        11,
                                                        16
                                                    )}`}
                                                </td>

                                                <td className="text-center align-middle">
                                                    {item.author_name}
                                                </td>
                                                <td className="text-center align-middle">
                                                    {item.check_id}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                        {lossSoldGoods.lastMonth.length > 4 && (
                            <div className="d-flex justify-content-center mt-3">
                                <button
                                    className="btn btn-sm main--button"
                                    onClick={handleShowMoreToggle}
                                >
                                    {showAllRows
                                        ? "Сховати"
                                        : "Показати більше"}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
